import { Card, Modal, Radio, Space, Tag, Typography } from 'antd';
import { useMemo, useState } from 'react';
import { getAddressType } from '../../../../utils';

const { Text } = Typography;

const DeliveryAddress = ({ open, onClose, details, onSelect, selectedAddress }) => {
    const [selectedId, setSelectedId] = useState(selectedAddress ? selectedAddress.id : null);

    const extractAddressLines = (item) => {
        if (!item) return [];
        return Object.keys(item)
            .filter((key) => /^address_\d+$/.test(key) && item[key]?.trim())
            .map((key) => item[key].trim());
    };

    const addressList = useMemo(() => {
        if (!Array.isArray(details)) return [];
        return details.map((item) => {
            const addressLines = extractAddressLines(item);
            const fullAddress = [...addressLines, item.city?.trim(), item.postcode?.trim()]
                .filter(Boolean)
                .join(', ');

            return {
                ...item,
                fullAddress,
            };
        });
    }, [details]);

    const handleConfirm = () => {
        const selected = addressList.find((a) => a.id === selectedId);
        if (selected) {
            onSelect(selected);
            onClose();
        }
    };

    return (
        <Modal
            title="Select Delivery Address"
            open={open}
            onCancel={onClose}
            onOk={handleConfirm}
            okButtonProps={{ disabled: selectedId === null }}
            width={650}
            centered
        >
            <Radio.Group
                value={selectedId}
                onChange={(e) => setSelectedId(e.target.value)}
                className="w-full address-radio-group"
            >
                <Space direction="vertical" className="w-full" size="middle">
                    {addressList.map((addr) => {
                        const isSelected = addr.id === selectedId;
                        return (
                            <Card
                                key={addr.id}
                                className="shadow-2"
                                size="small"
                                bordered={isSelected}
                                variant={isSelected ? 'bordered' : 'outlined'}
                                style={{
                                    cursor: 'pointer',
                                    borderColor: isSelected ? '#1677ff' : '#f0f0f0',
                                }}
                                onClick={() => setSelectedId(addr.id)}
                            >
                                <Radio value={addr.id} className="w-full">
                                    <div className="flex flex-column">
                                        <div className="flex justify-content-between align-items-center">
                                            {addr.addressee && <Text>{addr.addressee}</Text>}
                                            {getAddressType(addr) && <div><Tag color="gray">{getAddressType(addr)}</Tag></div>}
                                        </div>
                                        <Text type="secondary">{addr.fullAddress}</Text>
                                        {addr.address_delivery_instructions && (
                                            <Text italic type="secondary">
                                                {addr.address_delivery_instructions}
                                            </Text>
                                        )}
                                    </div>
                                </Radio>
                            </Card>
                        );
                    })}
                </Space>
            </Radio.Group>
        </Modal>
    );
};

export default DeliveryAddress;
